export const FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_REQUEST = 'FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_REQUEST';
export const FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_SUCCESS = 'FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_SUCCESS';
export const FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_FAILURE= 'FETCH_COMPACTING_DIV_AUTHORIZATION_DATA_FAILURE';

export const NAVIGATE_COMPACTING_DIV_AUTHORIZATION = 'NAVIGATE_COMPACTING_DIV_AUTHORIZATION'
    
export const NAVIGATE_COMPACTING_DIV_AUTHORIZATION_DETAILS = 'NAVIGATE_COMPACTING_DIV_AUTHORIZATION_DETAILS';

export const UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_REQUEST = 'UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_REQUEST';
export const UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_SUCCESS = 'UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_SUCCESS';
export const UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_FAILURE = 'UPDATE_COMPACTING_DIVISION_AUTHORIZATION_VERIFY_FAILURE';


export const FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_REQUEST = 'FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_REQUEST';
export const FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_SUCCESS = 'FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_SUCCESS';
export const FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_FAILURE = 'FETCH_COMPACTING_DIVISION_AUTHORIZATION_DETAIL_FAILURE';

export const COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET  = 'COMPACTING_DIVISION_AUTHORIZE_USERFORM_RESET';

export const COMPACTING_DIVISION_AUTHORIZED_BTN = 'COMPACTING_DIVISION_AUTHORIZED_BTN';